export enum FeederCardModal {
  BowlType = 1,
}
